import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import FullLayout from "./layouts/FullLayout";

// pages
import Dashboard from "./Dashboard";
import Login from "./Login.jsx";
import CustomerList from "./peday/CustomerList.jsx";
import LoanList from "./peday/LoanList.jsx";
import CollectionList from "./peday/CollectionList.jsx";
import DisbursementList from "./peday/DisbursementList.jsx";
import EmployeeList from "./peday/EmployeeList.jsx";
import CreditUnderwriting from "./peday/CreditUnderWriting.jsx";
import OverdueList from "./peday/OverdueList.jsx";
import TodayEmiSchedule from "./peday/TodayEmiSchedule.jsx";
import ProductList from "./peday/ProductList.jsx";
import RejectLoanList from "./peday/RejectedLoanList.jsx";
import Payment from "./peday/Payment.jsx";
import LoginFee from "./peday/LoginFee.jsx";
import Reporting from "./peday/reporting/Reporting.jsx";
import PayoutRequest from "./peday/PayoutRequest.jsx";
import CustomerView from "./peday/CustomerView.jsx";
import LoanView from "./peday/LoanView.jsx";
import MandateRegistration from "./peday/MandateRegistration.jsx";
import RecurringPayments from "./peday/RecurringPayments.jsx";
import MandateNotifications from "./peday/MandateNotifications.jsx";
import DisbursementView from "./peday/DisbursementView.jsx";
import EmployeeView from "./peday/EmployeeView.jsx";
import EmployeeForm from "./peday/EmployeeForm.jsx";
import AddLender from "./peday/AddLender.jsx";
import Privilege from "./peday/Privilege.jsx";
import AddProduct from "./peday/AddProduct.jsx";
import Blocked from "./peday/Blocked.jsx";
import RuleEngine from "./peday/RuleEngine.jsx";
import BreRulesList from "./peday/BreRulesList.jsx";
import RejectSummary from "./peday/RejectSummary.jsx";
import SoftApprovalList from "./peday/SoftApprovalList.jsx";
import BreRulesAgentList from "./peday/BreRulesAgentList.jsx";
import BreRulesFinanceList from "./peday/BreRulesFinanceList.jsx";
import StepStatus from "layouts/loader/StepStatus.jsx";
import BreButton from "./layouts/loader/BreButton.jsx";
import EmiCalculator from "./peday/EmiCalculator.jsx";
import CollectionCallerRemarks from "./peday/CollectionCallerRemarks/CollectionDashboard.jsx"
import CollectionCallerRemarksLayout from "./peday/CollectionCallerRemarks/CollectionCallerRemarksLayout.jsx"
import CallerAddGetRemarks from "./peday/CollectionCallerRemarks/CallerAddGetRemarks.jsx";
import AssignedCases from "./peday/CollectionCallerRemarks/AssignedCases.jsx";
import AllAssignedCases from "./peday/CollectionCallerRemarks/AllAssignedCases.jsx";
import CallerList from "./peday/CollectionCallerRemarks/CallerList.jsx";
import PromiseToPay from "./peday/CollectionCallerRemarks/PromiseToPay.jsx";
import OtherLspAssignedCases from "./peday/CollectionCallerRemarks/OtherLspAssignedCases.jsx";
import Company from "./peday/finance/Company.jsx";
import CompanyAddEdit from "./peday/finance/CompanyAddEdit.jsx";
import Branch from "./peday/finance/Branch.jsx";
import Agent from "./peday/finance/Agent.jsx";
import BranchAddEdit from "./peday/finance/BranchAddEdit.jsx";
import AgentAddEdit from "./peday/finance/AgentAddEdit.jsx";
import User from "./peday/finance/User.jsx";
import Wallet from "./peday/finance/Wallet.jsx";
import WalletTopUpRequest from "./peday/finance/WalletTopUpRequest.jsx";
import WalletTransactions from "./peday/finance/WalletTransactions.jsx";
import LoginFeeMaster from "./peday/LoginFeeMaster.jsx";


// redirect component that runs at render time
const HomeGate = () => {
  const token = localStorage.getItem("authToken");
  return <Navigate to={token ? "/Dashboard" : "/login"} replace />;
};

export default function App() {
  return (
    <div className="dark">
      <Routes>
        <Route path="/login" element={<Login />} />

   <Route
  path="/CollectionCallerRemarks"
  element={
    <ProtectedRoute privilegeKey="CallerTabView">
      <CollectionCallerRemarksLayout />
    </ProtectedRoute>
  }
>
  {/* DASHBOARD */}
  <Route index element={<CollectionCallerRemarks />} />

  {/* CALL REMARKS PAGE */}
  <Route path="remarks" element={<CallerAddGetRemarks />} />

  {/* PROMISE TO PAY */}
  <Route path="promise-to-pay" element={<PromiseToPay/>}/>

  <Route path="assigned-cases" element={<AssignedCases/>} />

  <Route
    path="all-assigned-cases"
    element={
      localStorage.getItem("isAdmin") === "1"
        ? <AllAssignedCases />
        : <Navigate to="/CollectionCallerRemarks/assigned-cases" replace />
    }
  />

  <Route path="caller-list" element={<CallerList/>} />

  <Route path="other-lsp-cases" element={<OtherLspAssignedCases/>} />

</Route>




        <Route path="/" element={<FullLayout />}>
          {/* index = "/" */}
          <Route index element={<HomeGate />} />

          {/* dashboard */}
          <Route
            path="Dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* protected tabs (relative paths) */}
          <Route
            path="CustomerList"
            element={
              <ProtectedRoute privilegeKey="customerTabView">
                <CustomerList />
              </ProtectedRoute>
            }
          />
          <Route
            path="LoanList"
            element={
              <ProtectedRoute privilegeKey="loanTabView">
                <LoanList />
              </ProtectedRoute>
            }
          />
          <Route
            path="CollectionList"
            element={
              <ProtectedRoute privilegeKey="collectionTabView">
                <CollectionList />
              </ProtectedRoute>
            }
          />
          <Route
            path="DisbursementList"
            element={
              <ProtectedRoute privilegeKey="disbursementTabView">
                <DisbursementList />
              </ProtectedRoute>
            }
          />
          <Route
            path="EmployeeList"
            element={
              <ProtectedRoute privilegeKey="employeeTabView">
                <EmployeeList />
              </ProtectedRoute>
            }
          />
          <Route
            path="CreditUnderwriting"
            element={
              <ProtectedRoute privilegeKey="creditTabView">
                <CreditUnderwriting />
              </ProtectedRoute>
            }
          />
          <Route
            path="OverdueList"
            element={
              <ProtectedRoute privilegeKey="overDewTabView">
                <OverdueList />
              </ProtectedRoute>
            }
          />
          <Route
            path="TodayEmiSchedule"
            element={
              <ProtectedRoute privilegeKey="todayEmiTabView">
                <TodayEmiSchedule />
              </ProtectedRoute>
            }
          />
          <Route
            path="MandateRegistration"
            element={
              <ProtectedRoute privilegeKey="MandateRegistrationView">
                <MandateRegistration/>
              </ProtectedRoute>
            }
          />
          <Route
            path="RecurringPayments"
            element={
              <ProtectedRoute privilegeKey="MandateRegistrationView">
                <RecurringPayments/>
              </ProtectedRoute>
            }
          />
          <Route
            path="MandateNotifications"
            element={
              <ProtectedRoute privilegeKey="MandateRegistrationView">
                <MandateNotifications/>
              </ProtectedRoute>
            }
          />
             <Route
            path="ProductList"
            element={
              <ProtectedRoute privilegeKey="productTabView">
                <ProductList />
              </ProtectedRoute>
            }
          />
          <Route
            path="RejectLoanList"
            element={
              <ProtectedRoute privilegeKey="rejectTabView">
                <RejectLoanList />
              </ProtectedRoute>
            }
          />
          <Route
            path="EmiCalculator"
            element={
              <ProtectedRoute privilegeKey="emiCalculateTabView">
                <EmiCalculator/>
              </ProtectedRoute>
            }
          />
          <Route
            path="Payment"
            element={
              <ProtectedRoute privilegeKey="paymentTabView">
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route
            path="LoginFee"
            element={
              <ProtectedRoute privilegeKey="LoginTabView">
                <LoginFee />
              </ProtectedRoute>
            }
          />
          <Route
           path="LoginFeeMaster"
           element={
    <ProtectedRoute privilegeKey="LoginTabView">
      <LoginFeeMaster />
    </ProtectedRoute>
  }
/>
          <Route
            path="StepStatus"
            element={
              <ProtectedRoute privilegeKey="appStatusView">
                <StepStatus />
              </ProtectedRoute>
            }
          />
          <Route
            path="Reporting"
            element={
              <ProtectedRoute privilegeKey="reportingTabView">
                <Reporting />
              </ProtectedRoute>
            }
          />
          <Route
            path="PayoutRequest"
            element={
              <ProtectedRoute privilegeKey="payoutRequestTabView">
                <PayoutRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="Blocked"
            element={
              <ProtectedRoute privilegeKey="blockTabView">
                <Blocked />
              </ProtectedRoute>
            }
          />

          {/* details */}
          <Route
            path="CustomerView"
            element={
              <ProtectedRoute privilegeKey="customerDetailsView">
                <CustomerView />
              </ProtectedRoute>
            }
          />
          <Route
            path="LoanView"
            element={
              <ProtectedRoute privilegeKey="loanDetailsView">
                <LoanView />
              </ProtectedRoute>
            }
          />
          <Route
            path="DisbursementView"
            element={
              <ProtectedRoute privilegeKey="disbursementDetailsView">
                <DisbursementView />
              </ProtectedRoute>
            }
          />
          <Route
            path="EmployeeView"
            element={
              <ProtectedRoute privilegeKey="employeeEdit">
                <EmployeeView />
              </ProtectedRoute>
            }
          />
          <Route
            path="EmployeeForm"
            element={
              <ProtectedRoute privilegeKey="addEmployeeTabView">
                <EmployeeForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="AddLender"
            element={
              <ProtectedRoute>
                <AddLender />
              </ProtectedRoute>
            }
          />
          <Route
            path="RuleEngine"
            element={
              <ProtectedRoute privilegeKey="creditTabView">
                <RuleEngine />
              </ProtectedRoute>
            }
          />
          <Route
            path="BreRulesList"
            element={
              <ProtectedRoute privilegeKey="creditTabView">
                <BreRulesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="RejectSummary"
            element={
              <ProtectedRoute privilegeKey="rejectTabView">
                <RejectSummary />
              </ProtectedRoute>
            }
          />
         <Route
            path="Company"
            element={
              <ProtectedRoute privilegeKey="companyTabView">
                <Company/>
              </ProtectedRoute>
            }
          />

              <Route
            path="CompanyAddEdit"
            element={
              <ProtectedRoute privilegeKey="companyTabView">
                <CompanyAddEdit/>
              </ProtectedRoute>
            }
          />

          <Route
            path="Branch"
            element={
              <ProtectedRoute privilegeKey="branchTabView">
                <Branch/>
              </ProtectedRoute>
            }
          />

          
          <Route
            path="BranchAddEdit"
            element={
              <ProtectedRoute privilegeKey="branchTabView">
                <BranchAddEdit/>
              </ProtectedRoute>
            }
          />

            <Route
            path="Agent"
            element={
              <ProtectedRoute privilegeKey="agentTabView">
                <Agent/>
              </ProtectedRoute>
            }
          />

           <Route
            path="AgentAddEdit"
            element={
              <ProtectedRoute privilegeKey="agentTabView">
                <AgentAddEdit/>
              </ProtectedRoute>
            }
          />

          
           <Route
            path="User"
            element={
              <ProtectedRoute privilegeKey="agentTabView">
                <User/>
              </ProtectedRoute>
            }
          />
         
         <Route
            path="Wallet"
            element={
              <ProtectedRoute privilegeKey="walletTabView">
                <Wallet/>
              </ProtectedRoute>
            }
          />

           <Route
            path="WalletTopUpRequest"
            element={
              <ProtectedRoute privilegeKey="walletTabView">
                <WalletTopUpRequest/>
              </ProtectedRoute>
            }
          />

          <Route
            path="WalletTransactions"
            element={
              <ProtectedRoute privilegeKey="walletTransactionView">
                <WalletTransactions/>
              </ProtectedRoute>
            }
          />

          <Route
            path="SoftApprovalList"
            element={
              <ProtectedRoute privilegeKey="creditTabView">
                <SoftApprovalList />
              </ProtectedRoute>
            }
          />
          <Route
            path="BreRulesAgentList"
            element={
              <ProtectedRoute privilegeKey="creditTabView">
                <BreRulesAgentList />
              </ProtectedRoute>
            }
          />
          <Route
            path="BreRulesFinanceList"
            element={
              <ProtectedRoute privilegeKey="financeBreView">
                <BreRulesFinanceList />
              </ProtectedRoute>
            }
          />

          {/* admin */}
          <Route
            path="Privilege"
            element={
              <ProtectedRoute privilegeKey="privilegeTabView">
                <Privilege />
              </ProtectedRoute>
            }
          />
          <Route
            path="AddProduct"
            element={
              <ProtectedRoute privilegeKey="addProductView">
                <AddProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="BreButton"
            element={
              <ProtectedRoute privilegeKey="breButtonView">
                <BreButton />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}